import { ITipProps, CreateTipInput } from "../lib/types/Tip";
import { Endpoints } from "../lib/endpoints";
import { PerformRequest } from "../lib/usePerformRequest";
import { PaginatedResponse, NonPaginatedResponse } from "../lib/types";

export async function getTips(
  page: number = 1,
  limit: number = 100
): Promise<ITipProps[]> {
  const result = await PerformRequest<PaginatedResponse<ITipProps[]>>({
    method: Endpoints.GetTipsList(page, limit).method as any,
    route: Endpoints.GetTipsList(page, limit).route,
  });

  if (result.status === 200) {
    return result.data.data;
  }
  return [];
}

export async function createTip(input: CreateTipInput): Promise<ITipProps> {
  const result = await PerformRequest<NonPaginatedResponse<ITipProps>>({
    method: Endpoints.CreateTip().method as any,
    route: Endpoints.CreateTip().route,
    data: input,
  });

  if (result.status === 201 || result.status === 200) {
    return result.data.data;
  }
  throw new Error(result.message);
}

export async function updateTip(
  id: string,
  update: Partial<Omit<ITipProps, "id">>
): Promise<ITipProps | null> {
  const result = await PerformRequest<NonPaginatedResponse<ITipProps>>({
    method: Endpoints.UpdateTip(id).method as any,
    route: Endpoints.UpdateTip(id).route,
    data: update,
  });

  if (result.status === 200) {
    return result.data.data;
  }
  return null;
}

export async function deleteTip(id: string): Promise<boolean> {
  const result = await PerformRequest<any>({
    method: Endpoints.DeleteTip(id).method as any,
    route: Endpoints.DeleteTip(id).route,
  });

  return result.status === 200;
}
